import { render, staticRenderFns } from "./DownloadedModelInstructions.vue?vue&type=template&id=36bb7ccf&scoped=true"
import script from "./DownloadedModelInstructions.vue?vue&type=script&lang=ts"
export * from "./DownloadedModelInstructions.vue?vue&type=script&lang=ts"
import style0 from "./DownloadedModelInstructions.vue?vue&type=style&index=0&id=36bb7ccf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bb7ccf",
  null
  
)

export default component.exports